import { render, staticRenderFns } from "./ChatVue.vue?vue&type=template&id=59c53109"
import script from "./ChatVue.vue?vue&type=script&lang=js"
export * from "./ChatVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports